import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import WhiteLabelOverviewCard from './WhiteLabelOverviewCard';

const WhiteLabelOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:whitelabel_organizations.title')} />
      <WhiteLabelOverviewCard />
    </ContentLayout>
  );
};

export default WhiteLabelOverviewPage;
